var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{directives:[{name:"auth",rawName:"v-auth",value:('archives_del'),expression:"'archives_del'"}],attrs:{"type":"text"},on:{"click":function($event){_vm.del()}}},[_vm._v(" 删除")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59c5df56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/oa/view/official/cmps/btnDel/src/btnDel.vue
// module id = null
// module chunks = 